import { Link } from "react-router-dom";

import { Card, CardContent, Grid } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const TermsAndConditions = () => {
  const url = process.env.REACT_APP_URL;
  return (
    <MDBox py={3}>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={10} lg={8}>
          <Card>
            <CardContent>
              <MDBox textAlign="center" mb={2}>
                <MDTypography mt={4} variant="h4" fontWeight="medium">
                  ToMarket Terms and Conditions
                </MDTypography>
              </MDBox>

              <MDBox p={1}>
                <MDTypography variant="h5" fontWeight="medium" gutterBottom>
                  Effective Date: April 2025
                </MDTypography>
                <MDTypography variant="body2" paragraph>
                  Welcome to ToMarket! These ToMarket Terms and Conditions (“Terms”) apply to your
                  use of the mobile applications and websites operated by Find Better Food, Inc. and
                  its subsidiaries and affiliates (collectively, “ToMarket” or “we”, “us” or “our”).
                  By visiting our websites, including, but not limited to,{" "}
                  <Link to={url} target="_blank">
                    ToMarket.com
                  </Link>
                  , the ToMarket App, a mobile application available through the Apple App Store and
                  the Google Play Store, interacting with us on other platforms (including, but not
                  limited to, social media sites such as Facebook, Instagram and LinkedIn) and/or
                  submitting anything to us through our websites and mobile applications or other
                  platforms operated by us or on our behalf (collectively, our “Platform”),you agree
                  to read, comply with and be legally bound by:
                </MDTypography>
                <ol style={{ listStyleType: "lower-roman", paddingLeft: "4rem" }}>
                  <li>
                    <MDTypography variant="body2">These Terms and</MDTypography>
                  </li>
                  <li>
                    <MDTypography variant="body2">
                      Any additional terms and conditions, agreements, policies and additional terms
                      published on the Platform or otherwise applicable to your use of the Platform
                      (the “Rules”).
                    </MDTypography>
                  </li>
                </ol>
                <MDTypography mt={2} variant="body2" paragraph>
                  You also agree that you may be bound by, and agree to comply with, as applicable
                  to you, any agreements between us and a third party on whose behalf you access our
                  Platform (“Customer Agreement”). These Terms, the Rules and Customer Agreements
                  are collectively referred to in these Terms as the “Agreements”. If you do not
                  agree with the foregoing, you may not use the Platform.
                </MDTypography>

                <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                  REVIEW THESE TERMS CAREFULLY. THESE TERMS REQUIRE THE USE OF ARBITRATION ON AN
                  INDIVIDUAL BASIS TO RESOLVE DISPUTES, RATHER THAN COURT OR JURY TRIALS OR CLASS
                  ACTIONS AND ALSO LIMIT THE REMEDIES AVAILABLE TO YOU IN THE EVENT OF A DISPUTE.
                  CAREFULLY REVIEW THE DISPUTE RESOLUTION SECTION OF THESE TERMS BEFORE YOU USE OUR
                  PLATFORM.
                </MDTypography>

                {/* 1 */}
                <MDBox>
                  <MDTypography variant="h5" fontWeight="medium" gutterBottom>
                    1. ACCEPTANCE AND APPLICABILITY OF AGREEMENTS
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    1.1 Acceptance and Applicability
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    By using the Platform and/or acknowledging that you have read and agree to any
                    or all of the Agreements, you are agreeing to comply with the applicable
                    Agreements. If you fail to comply with any of the applicable Agreements, we may
                    terminate your ability to use the Platform. Without limiting the foregoing, the
                    Platform is intended for adults 18 years of age or older (or age of majority if
                    higher in your place of residence). By accessing the Platform, you represent to
                    us that:
                  </MDTypography>
                  <ol style={{ listStyleType: "lower-alpha", paddingLeft: "4rem" }}>
                    <li>
                      <MDTypography variant="body2">
                        You are 18 years of age or older (or age of majority or older if higher in
                        your place of residence.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2">
                        You are legally able to enter into contracts.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2">
                        You are not a person barred from receiving or using the Platform under
                        federal, state, local or other laws.
                      </MDTypography>
                    </li>
                  </ol>

                  <MDTypography mt={2} ml={2} variant="body2" paragraph>
                    Additionally, your access to and use of the Platform may be available pursuant
                    to or otherwise subject to a Customer Agreement between ToMarket and your
                    employer or another entity on whose behalf you use the Platform. If this is the
                    case, your employer or such other entity may impose additional obligations on
                    your use of the Platform (“Additional Obligations”), and, in addition to the
                    foregoing, you also represent to us that your use of the Platform will comply
                    with the applicable Customer Agreements and any applicable Additional
                    Obligations.
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    1.2 Changes to Terms
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    We may update or modify these Terms from time-to-time without providing notice
                    to you by posting a revised version of these Terms on our website. You can
                    review the most current version of these Terms at any time by clicking the
                    “Terms and Conditions” link on our website. By using the Platform after any
                    modification of these Terms, you agree to be bound by such modifications.
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    1.3 Our Rights
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    We reserve the right to take any of the following actions at our sole
                    discretion:
                  </MDTypography>
                  <ol style={{ listStyleType: "lower-alpha", paddingLeft: "4rem" }}>
                    <li>
                      <MDTypography variant="body2">
                        Change or terminate all or any part of the Platform.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2">
                        Restrict or terminate your access to all or any part of the Platform.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2">
                        Refuse, move or remove any content that is available on the Platform.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2">
                        Deny access to the Platform to anyone at any time in our sole and absolute
                        discretion.
                      </MDTypography>
                    </li>
                  </ol>

                  <MDTypography mt={2} ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    1.4 Conflicts
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    In the event of any conflict between these Terms and any other Agreement, these
                    Terms shall control.
                  </MDTypography>
                </MDBox>

                {/* 2 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    2. USE OF THE PLATFORM
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    2.1 Acceptable Use
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    Your use must comply with these Acceptable Use Restrictions:
                  </MDTypography>
                  <ol style={{ listStyleType: "lower-alpha", paddingLeft: "4rem" }}>
                    <li>
                      <MDTypography variant="body2">
                        You are only allowed to use the Platform for its intended purposes, as
                        determined by us in our sole discretion.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2">
                        Without limitation, you are not allowed to use the Platform to:
                      </MDTypography>
                      <ol style={{ listStyleType: "lower-roman", paddingLeft: "2rem" }}>
                        <li>
                          <MDTypography variant="body2">
                            Publish, post, distribute or disseminate any defamatory, infringing,
                            obscene, pornographic, sexual, indecent or unlawful material or
                            information, or engage in criminal behavior, or cause others to engage
                            in any of the aforementioned conduct.
                          </MDTypography>
                        </li>
                        <li>
                          <MDTypography variant="body2">Violate any laws.</MDTypography>
                        </li>
                        <li>
                          <MDTypography variant="body2">
                            Transmit or upload any software or other materials that contain any
                            viruses, worms, trojan horses, defects, time bombs or other items of a
                            destructive nature.
                          </MDTypography>
                        </li>
                        <li>
                          <MDTypography variant="body2">
                            Engage in commercial activity except as authorized under the applicable
                            Agreements.
                          </MDTypography>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <MDTypography variant="body2">You must not:</MDTypography>
                      <ol style={{ listStyleType: "lower-roman", paddingLeft: "2rem" }}>
                        <li>
                          <MDTypography variant="body2">
                            Reformatting or framing any portion of the Platform.
                          </MDTypography>
                        </li>
                        <li>
                          <MDTypography variant="body2">
                            Using any device, software or procedure that interferes with, or
                            attempts to interfere with, the normal operation of the Platform.
                          </MDTypography>
                        </li>
                        <li>
                          <MDTypography variant="body2">
                            Taking any action that imposes, or may impose, an unreasonable or
                            disproportionately large load on our information technology
                            infrastructure.
                          </MDTypography>
                        </li>
                        <li>
                          <MDTypography variant="body2">
                            Modifying, adapting, translating or reverse engineering any portion of
                            the Platform.
                          </MDTypography>
                        </li>
                        <li>
                          <MDTypography variant="body2">
                            Disrupting or otherwise interfering with the Platform or the networks or
                            servers we use.
                          </MDTypography>
                        </li>
                        <li>
                          <MDTypography variant="body2">
                            Impersonating any person or entity or misrepresenting your connection or
                            affiliation with a person or entity.
                          </MDTypography>
                        </li>
                        <li>
                          <MDTypography variant="body2">
                            Collecting or storing, or attempting to collect or store, personal
                            information about other users of the Platform for any purpose other than
                            engaging in transactions facilitated through the normal use of the
                            Platform.
                          </MDTypography>
                        </li>
                        <li>
                          <MDTypography variant="body2">
                            Engaging in any activity that is illegal under federal, state, local or
                            other laws.
                          </MDTypography>
                        </li>
                      </ol>
                    </li>
                  </ol>

                  <MDTypography mt={2} ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    2.2 Access to the Platform
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    Access to the Platform requires access to the Internet. You are responsible for
                    providing all equipment necessary to establish a connection to the Internet,
                    access to the Internet and any telephone, wireless or other connection and
                    service fees associated with such access. Using the Platform may allow you to
                    receive Content on your mobile phone or wireless device. The manner in which
                    Content is delivered to your phone or device may cause you to incur extra data,
                    text messaging or other charges from your wireless carrier, which are your sole
                    responsibility.
                  </MDTypography>
                </MDBox>

                {/* 3 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    3. OWNERSHIP OF THE PLATFORM AND CONTENT
                  </MDTypography>
                  <MDTypography mt={2} ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    3.1 Ownership
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    All right, title and interest in and to the Platform, including, but not limited
                    to, all of the software and code that comprise and operate the Platform
                    (collectively, the “Software”), and all of the text, photographs, illustrations,
                    images, graphics, audio, video, URLs, advertising copy and other materials
                    provided through the Platform (collectively, the “Content”) are owned by us or
                    by third parties who have licensed their Content to us. The Platform is
                    protected under trademark, service mark, trade dress, copyright, patent, trade
                    secret and other intellectual property laws. In addition, the entire Content of
                    the Platform is a collective work under U.S. and international copyright laws
                    and treaties, and we own the copyright in the selection, coordination,
                    arrangement and enhancement of the Content.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    3.2 Limited License
                  </MDTypography>

                  <MDTypography ml={2} variant="body2" paragraph>
                    Subject to your acceptance of, and compliance with, the Agreements, we hereby
                    grant you a limited, non-exclusive, non-transferable, non-sublicensable,
                    revocable right to access and use the Platform in a manner that is consistent
                    with the Agreements and the Platform’s intended purpose(s). You obtain no rights
                    to the Platform except to use it in accordance with the Agreements. Without
                    limiting the generality of the foregoing, you shall not engage in the following
                    Prohibited Activities:
                  </MDTypography>

                  <ol style={{ listStyleType: "lower-roman", paddingLeft: "4rem" }}>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Use any data mining, robots, or other automatic or manual device, software,
                        program, code, algorithm or methodology to access, copy or monitor any
                        portion of the Platform, or reproduce or circumvent the Platform’s structure
                        or obtain any materials or information not intentionally made available.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Reproduce, copy, duplicate, redistribute, publish, reverse engineer,
                        decompile, disassemble, modify, translate or attempt to create derivative
                        works of the Platform (in whole or in part).
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Sell, assign, sublicense, transfer, distribute, lease or grant a security
                        interest in the Platform (in whole or in part).
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Make the Platform (in whole or in part) available to any third party through
                        a network, including use across multiple devices simultaneously.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Export the Platform (in whole or in part) to any country outside the United
                        States, whether physically or electronically.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Use the Platform in a manner prohibited by applicable laws, regulations, or
                        the Agreements.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Use the Platform in violation of the Acceptable Use Restrictions.
                      </MDTypography>
                    </li>
                  </ol>

                  <MDTypography ml={2} variant="body2" paragraph>
                    You will be solely liable for any damages, costs, or expenses arising out of or
                    in connection with your commission of any Prohibited Activity. You must notify
                    us immediately if you become aware of such activity and cooperate with any
                    investigation we undertake.
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    3.3 Our Marks
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    The ToMarket names and logos (including, but not limited to, those of our
                    affiliates), all product and service names, all graphics, all button icons and
                    all trademarks, service marks and logos appearing within the Platform, unless
                    otherwise noted, are trademarks (whether registered or not), service marks
                    and/or trade dress of ToMarket (collectively, “Our Marks”). All other
                    trademarks, product names, company names, logos, service marks and/or trade
                    dress (collectively, “Marks”) mentioned, displayed, cited or otherwise indicated
                    within the Platform are the property of their respective owners. You are not
                    authorized to display Our Marks in any manner without our prior written
                    permission. You are not authorized to display or use the Marks of any third
                    party that appear within the Platform without the prior written permission of
                    the applicable third party.
                  </MDTypography>
                </MDBox>

                {/* 4 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    4. OWNERSHIP OF THE PLATFORM AND CONTENT
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    4.1 Registration
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    The ToMarket names and logos (including, but not limited to, those of our
                    affiliates), all product and service names, all graphics, all button icons and
                    all trademarks, service marks and logos appearing within the Platform, unless
                    otherwise noted, are trademarks (whether registered or not), service marks
                    and/or trade dress of ToMarket (collectively, “Our Marks”). All other
                    trademarks, product names, company names, logos, service marks and/or trade
                    dress (collectively, “Marks”) mentioned, displayed, cited or otherwise indicated
                    within the Platform are the property of their respective owners. You are not
                    authorized to display Our Marks in any manner without our prior written
                    permission. You are not authorized to display or use the Marks of any third
                    party that appear within the Platform without the prior written permission of
                    the applicable third party.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    4.2 Account Security and Responsibility
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    The ToMarket names and logos (including, but not limited to, those of our
                    affiliates), all product and service names, all graphics, all button icons and
                    all trademarks, service marks and logos appearing within the Platform, unless
                    otherwise noted, are trademarks (whether registered or not), service marks
                    and/or trade dress of ToMarket (collectively, “Our Marks”). All other
                    trademarks, product names, company names, logos, service marks and/or trade
                    dress (collectively, “Marks”) mentioned, displayed, cited or otherwise indicated
                    within the Platform are the property of their respective owners. You are not
                    authorized to display Our Marks in any manner without our prior written
                    permission. You are not authorized to display or use the Marks of any third
                    party that appear within the Platform without the prior written permission of
                    the applicable third party.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    4.3 Additional Information Sharing
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    The ToMarket names and logos (including, but not limited to, those of our
                    affiliates), all product and service names, all graphics, all button icons and
                    all trademarks, service marks and logos appearing within the Platform, unless
                    otherwise noted, are trademarks (whether registered or not), service marks
                    and/or trade dress of ToMarket (collectively, “Our Marks”). All other
                    trademarks, product names, company names, logos, service marks and/or trade
                    dress (collectively, “Marks”) mentioned, displayed, cited or otherwise indicated
                    within the Platform are the property of their respective owners. You are not
                    authorized to display Our Marks in any manner without our prior written
                    permission. You are not authorized to display or use the Marks of any third
                    party that appear within the Platform without the prior written permission of
                    the applicable third party.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    4.4 Our Termination or Suspension of Your Account
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    The ToMarket names and logos (including, but not limited to, those of our
                    affiliates), all product and service names, all graphics, all button icons and
                    all trademarks, service marks and logos appearing within the Platform, unless
                    otherwise noted, are trademarks (whether registered or not), service marks
                    and/or trade dress of ToMarket (collectively, “Our Marks”). All other
                    trademarks, product names, company names, logos, service marks and/or trade
                    dress (collectively, “Marks”) mentioned, displayed, cited or otherwise indicated
                    within the Platform are the property of their respective owners. You are not
                    authorized to display Our Marks in any manner without our prior written
                    permission. You are not authorized to display or use the Marks of any third
                    party that appear within the Platform without the prior written permission of
                    the applicable third party.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    4.5 Cancellation
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    You may close your account at any time by contacting us at{" "}
                    <strong>info@tomarket.com </strong>and following the instructions we provide. If
                    you cancel your account, these Terms shall be terminated and your license to
                    access and use our Platform shall immediately terminate and you must discontinue
                    all use of the Platform. Please note, canceling your account will not:
                  </MDTypography>
                  <ol style={{ listStyleType: "lower-roman", paddingLeft: "4rem" }}>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Terminate any applicable Customer Agreement(s).
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Relieve you of any liabilities or obligations arising from your activity on
                        the Platform prior to cancellation.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Sell, assign, sublicense, transfer, distribute, lease or grant a security
                        interest in the Platform (in whole or in part).
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Make the Platform (in whole or in part) available to any third party through
                        a network, including use across multiple devices simultaneously.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Export the Platform (in whole or in part) to any country outside the United
                        States, whether physically or electronically.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Use the Platform in a manner prohibited by applicable laws, regulations, or
                        the Agreements.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Use the Platform in violation of the Acceptable Use Restrictions.
                      </MDTypography>
                    </li>
                  </ol>
                </MDBox>

                {/* 5 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    5. PRODUCT LISTINGS
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    5.1 Brands
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    The Platform enables certain users to obtain information on the sale of its
                    products through enrolled Distributors (“Brands”).
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    5.2 Distributors
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    The Platform enables certain users to consolidate sales data of products by its
                    enrolled Brands (“Distributors”).
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    5.3 Activities Outside the Platform
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    You are prohibited from using the Platform in any way that is designed to
                    complete or facilitate an order outside of the Platform. Without limiting the
                    foregoing, Brands and Distributors shall not:
                  </MDTypography>

                  <ol style={{ listStyleType: "lower-roman", paddingLeft: "4rem" }}>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Engage in any action with another user on the Platform designed to
                        circumvent the Platform’s intended use.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Refer to or promote external websites that facilitate sales of products
                        outside the Platform.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Use contact information obtained through the Platform to offer to buy or
                        sell products outside of the Platform.
                      </MDTypography>
                    </li>
                  </ol>
                  <MDTypography ml={2} variant="body2" paragraph>
                    For clarity, the foregoing prohibitions are not intended to prevent, restrict or
                    otherwise prohibit communications between Brands and Distributors that have a
                    pre-existing relationship outside of the Platform and/or communications
                    necessary to complete an order placed through the Platform.
                  </MDTypography>
                </MDBox>

                {/* 6 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    6. YOUR CONTENT, STATEMENTS AND PERSONAL INFORMATION
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    6.1 User Content
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    The Platform may provide you with the ability to add, create, upload, submit,
                    distribute, post or share content on or through the Platform, including, but not
                    limited to, website links, opinions, information, photos, profiles, videos and
                    audio clips (collectively, “User Content”). By providing any User Content on the
                    Platform, you expressly grant, and represent and warrant that you have the right
                    to grant, us a non-exclusive, irrevocable, worldwide, transferable,
                    royalty-free, perpetual license to publicly display, publicly perform,
                    reproduce, distribute, create derivative works of, and sublicense your User
                    Content in any manner or through any media now known or later developed without
                    any payment obligation to you. Without limiting the foregoing, any User Content
                    you provide on the Platform may be viewable by any other users of the Platform
                    (whether registered or unregistered). Further, you understand and agree that we
                    have the right, but not the duty, to pre-screen, edit, refuse, move or remove
                    any User Content posted to the Platform.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    6.2 Private Messages
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    The Platform may provide you with the ability to send private messages to other
                    users of the Platform (“Private Messages”). Private Messages are not considered
                    User Content and we will not intentionally make any such Private Messages
                    available to any party other than the intended recipient. However, you should
                    remain mindful that there is an inherent risk in the use of the Internet.
                    Private Messages may be intercepted without our knowledge or consent, collected
                    illegally and/or forwarded by recipients to others. We cannot guarantee the
                    security of any information, including your Private Messages, that you disclose
                    online, and you do so at your own risk.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    6.3 Abusive and Offensive Language
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    Abusive or offensive language will not be tolerated on our Platform, social
                    media sites or with our personnel. You are not entitled to make untrue,
                    malicious and/or damaging comments with regard to our operations in any media or
                    forum.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    6.4 Personal Data
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    By using the Platform, you are consenting to our collection, use, disclosure,
                    transfer and sharing of your personal information, including, but not limited
                    to, sharing such information with companies other than ToMarket as described in
                    our Privacy Policy (available at{" "}
                    <Link to={`${url}/privacy`} target="_blank">
                      ToMarket.com/privacy
                    </Link>{" "}
                    ). Our Privacy Policy may be updated from time to time, so please review it
                    regularly. If you do not accept the terms of our Privacy Policy, please
                    discontinue use of the applicable portions of the Platform.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    6.5 Feedback
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    By submitting ideas, suggestions, documents, proposals, products and/or
                    technologies (“Feedback”) to us in any way, you acknowledge and agree that:
                  </MDTypography>

                  <ol style={{ listStyleType: "lower-roman", paddingLeft: "4rem" }}>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Your Feedback does not contain confidential or proprietary information.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        We are not under any obligation of confidentiality, express or implied, with
                        respect to the Feedback.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        We shall be entitled to disclose (or choose not to disclose) such Feedback
                        for any purpose and in any way.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        We may have something similar to the Feedback already under consideration or
                        in development.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Your Feedback, unless subject to a patent, automatically becomes our
                        property without any obligation to you.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        You are not entitled to any compensation or reimbursement of any kind from
                        us under any circumstances.
                      </MDTypography>
                    </li>
                  </ol>
                </MDBox>

                {/* 7 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    7. TERMINATION
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    7.1 Right to Terminate
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    In addition to, and not in lieu of, any of our other rights set forth in these
                    Terms, we reserve the right, with or without notice and in our sole discretion,
                    to terminate these Terms, your account and/or your ability to access the
                    Platform for any reason, including, without limitation, for lack of use or if we
                    believe that you have violated or acted inconsistently with the letter or spirit
                    of these Terms, or in the case of any activity by you that may harm ToMarket or
                    other users, including, but not limited to, fraud, abuse of promotions or
                    privileges or misuse of the Platform. You agree that we will not be liable to
                    you or any third party for any such termination.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    7.2 Effects of Termination
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    If we exercise our termination rights available under these Agreements, your
                    license to access and use our Platform shall immediately terminate and you must
                    discontinue all use of the Platform affected by such termination.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    7.3 Fraudulent Activity
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    If we suspect that you are engaging in any fraudulent, abusive or illegal
                    activity, we may refer such matter to appropriate law enforcement authorities.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    7.4 Survival
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    The provisions of these Terms which by their nature are intended to survive the
                    termination or cancellation of these Terms shall continue as valid and
                    enforceable obligations notwithstanding any such termination or cancellation.
                    Without limiting the foregoing, the provisions of these Terms regarding
                    indemnity and limitations of liability shall survive the termination or
                    cancellation of these Terms.
                  </MDTypography>
                </MDBox>

                {/* 8 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    8. USER AND THIRD PARTY CONTENT
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    8.1 User Content
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    Reliance on User Content is at your own risk. We do not participate in any way
                    in the development of any User Content. You acknowledge and agree that we and
                    other third parties are not responsible or liable for, nor do we endorse, any
                    User Content that appears on the Platform.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    8.2 Links to Third Party Websites
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    Our Platform may include links to other websites (e.g., sponsors’ and/or
                    advertisers’ websites) or services solely as a convenience to you. You
                    acknowledge and agree that we are not responsible for the availability of such
                    external sites or resources and that we do not endorse and are not responsible
                    or liable for any such linked sites or other information, material, products or
                    services contained on other linked sites or accessible through other linked
                    sites. Furthermore, we make no express or implied warranties with regard to the
                    information, material, products or services that are contained on or accessible
                    through linked sites. Your access to and use of linked sites, including
                    information, material, products and services on linked sites or available
                    through linked sites is solely at your own risk.
                  </MDTypography>
                </MDBox>

                {/* 9 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    9. YOUR LIABILITY
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    9.1 Agreement to Indemnify
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    YOU AGREE THAT YOU WILL ONLY USE THE PLATFORM IN ACCORDANCE WITH THE APPLICABLE
                    AGREEMENTS. YOU WILL COMPENSATE US IN FULL FOR ANY LOSSES OR COSTS (INCLUDING
                    REASONABLE ATTORNEY’S FEES) WHICH WE (OR ANY OF OUR SUBSIDIARIES OR AFFILIATED
                    COMPANIES) INCUR ARISING FROM ANY BREACH BY YOU OF THE AGREEMENTS. WITHOUT
                    LIMITING THE GENERALITY OF THE FOREGOING AND TO THE EXTENT PERMITTED BY LAW, YOU
                    AGREE TO INDEMNIFY, DEFEND AND HOLD US, OUR SUBSIDIARIES AND AFFILIATES AND OUR
                    AND THEIR RESPECTIVE DIRECTORS, OFFICERS, EMPLOYEES, AGENTS AND OTHER PARTNERS
                    (THE “RELEASED PARTIES”) HARMLESS FROM AND AGAINST ANY CLAIM OR DEMAND,
                    INCLUDING REASONABLE ATTORNEY’S FEES, MADE BY ANY THIRD PARTY DUE TO OR ARISING
                    OUT OF YOUR USE OF THE PLATFORM, YOUR CONNECTION TO THE PLATFORM, YOUR VIOLATION
                    OF ANY OF THE AGREEMENTS OR YOUR VIOLATION OF ANY INTELLECTUAL PROPERTY RIGHTS
                    OF ANY OTHER PERSON OR ENTITY.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    9.2 Additional Remedies
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    The Released Parties reserve the right to seek all remedies available at law and
                    in equity for violations of the applicable Agreements, including the right to
                    block access from a particular Internet address to the Platform or report
                    misuses to law enforcement.
                  </MDTypography>
                </MDBox>

                {/* 10 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    10. YOUR LIABILITY
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    10.1 Disclaimer of all Warranties
                  </MDTypography>
                  <ol style={{ listStyleType: "lower-roman", paddingLeft: "4rem" }}>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        THE PLATFORM IS PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS AND WE
                        EXPRESSLY DISCLAIM ALL WARRANTIES OF ANY KIND RELATING TO THE PLATFORM
                        (INCLUDING, BUT NOT LIMITED TO, ANY SOFTWARE COMPRISING ANY PORTION OF THE
                        PLATFORM), WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE
                        IMPLIED WARRANTIES OF MERCHANTABILITY, TITLE, FITNESS FOR A PARTICULAR
                        PURPOSE, NON-INFRINGEMENT OR THAT THE PLATFORM WILL BE WITHOUT ERROR OR
                        INVULNERABLE TO VIRUSES, WORMS OR OTHER HARMFUL SOFTWARE OR HARDWARE.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        YOU HEREBY ACKNOWLEDGE THAT THE PLATFORM MAY NOT BE AVAILABLE DUE TO ANY
                        NUMBER OF FACTORS INCLUDING, BUT NOT LIMITED TO, PERIODIC SYSTEM
                        MAINTENANCE, SCHEDULED OR UNSCHEDULED, ACTS OF GOD, UNAUTHORIZED ACCESS,
                        VIRUSES, DENIAL OF SERVICE OR OTHER ATTACKS, TECHNICAL FAILURE OF THE
                        PLATFORM AND/OR TELECOMMUNICATIONS INFRASTRUCTURE OR DISRUPTION, AND
                        THEREFORE WE EXPRESSLY DISCLAIM ANY EXPRESS OR IMPLIED WARRANTY REGARDING
                        THE USE AND/OR AVAILABILITY, ACCESSIBILITY, SECURITY OR PERFORMANCE OF THE
                        PLATFORM CAUSED BY SUCH FACTORS.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        WE DO NOT MAKE ANY REPRESENTATIONS OR WARRANTIES AGAINST THE POSSIBILITY OF
                        DELETION, MISDELIVERY OR FAILURE TO STORE COMMUNICATIONS, PERSONALIZED
                        SETTINGS OR OTHER DATA, INCLUDING WITHOUT LIMITATION, ANY USER CONTENT OR
                        PRIVATE MESSAGES.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES.
                        ACCORDINGLY, SOME OF THE ABOVE DISCLAIMERS OF WARRANTIES MAY NOT APPLY TO
                        YOU.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Export the Platform (in whole or in part) to any country outside the United
                        States, whether physically or electronically.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Use the Platform in a manner prohibited by applicable laws, regulations, or
                        the Agreements.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Use the Platform in violation of the Acceptable Use Restrictions.
                      </MDTypography>
                    </li>
                  </ol>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    10.2 Use of Platform at Your Sole Risk
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    YOUR ACCESS TO THE PLATFORM, DOWNLOAD OF ANY SOFTWARE RELATING TO THE PLATFORM
                    AND USE OF ANY INFORMATION WE MAY PROVIDE IN CONNECTION WITH YOUR USE OF THE
                    PLATFORM IS AT YOUR SOLE OPTION, DISCRETION AND RISK. WE SHALL NOT BE LIABLE FOR
                    ANY MALFUNCTIONS OF THE COMPUTER PROGRAMS RELATING TO THE PLATFORM, BUGS OR
                    VIRUSES RESULTING IN LOST DATA OR ANY OTHER DAMAGE TO YOUR COMPUTER EQUIPMENT,
                    MOBILE PHONE OR MOBILE DEVICE OR SOFTWARE. FURTHERMORE, WE SHALL NOT BE LIABLE
                    FOR ANY ATTEMPTS BY YOU TO USE THE PLATFORM BY METHODS, MEANS OR WAYS NOT
                    INTENDED BY US. WE ARE NOT REQUIRED TO PROVIDE REDUNDANT OR BACKUP NETWORKS
                    AND/OR SYSTEMS.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    10.3 No Creation of Warranty
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN OBTAINED BY YOU FROM ANY OF
                    THE RELEASED PARTIES THROUGH OR FROM THE PLATFORM SHALL CREATE ANY WARRANTY NOT
                    EXPRESSLY STATED IN THESE TERMS.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    10.4 Third Party Statements
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    WE DO NOT ENDORSE AND ARE NOT RESPONSIBLE FOR STATEMENTS, ADVICE AND OPINIONS
                    MADE BY ANYONE OTHER THAN AUTHORIZED TOMARKET SPOKESPERSONS. WE DO NOT ENDORSE
                    AND ARE NOT RESPONSIBLE FOR ANY STATEMENTS, ADVICE OR OPINIONS CONTAINED
                    PROVIDED BY ANY THIRD PARTIES, AND SUCH STATEMENTS, ADVICE AND OPINIONS DO NOT
                    IN ANY WAY REFLECT THE STATEMENTS, ADVICE OR OPINIONS OF TOMARKET.
                  </MDTypography>
                </MDBox>

                {/* 11 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    11. LIMITATION OF LIABILITY
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    11.1 Maximum Liability
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, AND WITHOUT LIMITING ANYTHING
                    ELSE IN THESE TERMS, OUR ENTIRE LIABILITY, AND YOUR EXCLUSIVE REMEDY, WITH
                    RESPECT TO YOUR USE OF THE PLATFORM SHALL BE THE AMOUNT OF $100.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    11.2 No Liability for Incidental Damages
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    IN NO EVENT WILL WE BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY,
                    PUNITIVE OR CONSEQUENTIAL DAMAGES ARISING FROM YOUR USE OF THE PLATFORM OR FOR
                    ANY OTHER CLAIM RELATED IN ANY WAY TO YOUR USE OF THE PLATFORM.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    11.3 Applicability of Limitations
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    THE FOREGOING LIMITATIONS WILL APPLY WHETHER SUCH DAMAGES ARISE OUT OF BREACH OF
                    CONTRACT, TORT (INCLUDING NEGLIGENCE) OR OTHERWISE AND REGARDLESS OF WHETHER
                    SUCH DAMAGES WERE FORESEEABLE OR WE WERE ADVISED OF THE POSSIBILITY OF SUCH
                    DAMAGES. SOME STATES OR JURISDICTIONS DO NOT ALLOW CERTAIN LIMITATIONS OF
                    LIABILITY, SO SOME OF THE ABOVE LIMITATIONS OF LIABILITY MAY NOT APPLY TO YOU.
                    IN SUCH STATES OR JURISDICTIONS, OUR LIABILITY WILL BE LIMITED TO THE MAXIMUM
                    EXTENT PERMITTED BY APPLICABLE LAW.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    11.4 Notice to California Residents
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    IF YOU ARE A CALIFORNIA RESIDENT, YOU HEREBY WAIVE CALIFORNIA CIVIL CODE SECTION
                    1542 IN CONNECTION WITH THE FOREGOING, WHICH STATES “A GENERAL RELEASE DOES NOT
                    EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR
                    HER FAVOR AT THE TIME OF EXECUTING THE RELEASED, WHICH IF KNOWN BY HIM OR HER
                    MUST HAVE MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE DEBTOR.”
                  </MDTypography>
                </MDBox>

                {/* 12 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    12. DISPUTE RESOLUTION
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    PLEASE READ THIS SECTION CAREFULLY. IT AFFECTS YOUR RIGHTS.
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    12.1 Binding Arbitration and Class Action Waiver.
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    EXCEPT FOR DISPUTES THAT QUALIFY FOR SMALL CLAIMS COURT, YOU AND TOMARKET AGREE
                    THAT ALL DISPUTES, CLAIMS, OR CONTROVERSIES ARISING OUT OF OR RELATING IN ANY
                    WAY TO THE AGREEMENTS, YOUR USE OF THE PLATFORM, OR YOUR relationship WITH
                    TOMARKET SHALL BE RESOLVED EXCLUSIVELY THROUGH FINAL AND BINDING ARBITRATION,
                    AND NOT IN COURT. THIS AGREEMENT TO ARBITRATE APPLIES TO ALL CLAIMS, WHETHER
                    BASED IN CONTRACT, TORT, STATUTE, FRAUD, MISREPRESENTATION, OR ANY OTHER LEGAL
                    THEORY.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    12.2 Arbitration Procedures
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    ARBITRATION SHALL BE ADMINISTERED BY THE AMERICAN ARBITRATION ASSOCIATION
                    (“AAA”) IN ACCORDANCE WITH ITS COMMERCIAL ARBITRATION RULES AND, IF APPLICABLE,
                    THE AAA’S SUPPLEMENTARY PROCEDURES FOR CONSUMER-RELATED DISPUTES. THE
                    ARBITRATION SHALL BE CONDUCTED BY A SINGLE ARBITRATOR AND WILL TAKE PLACE IN
                    DENVER, COLORADO, UNLESS THE PARTIES AGREE OTHERWISE IN WRITING. JUDGMENT ON THE
                    ARBITRATION AWARD MAY BE ENTERED IN ANY COURT OF COMPETENT JURISDICTION.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    12.3 Individual Proceedings Only
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    YOU AND TOMARKET AGREE THAT ANY DISPUTE RESOLUTION PROCEEDINGS WILL BE CONDUCTED
                    ONLY ON AN INDIVIDUAL BASIS AND NOT IN A CLASS, CONSOLIDATED, COLLECTIVE, OR
                    REPRESENTATIVE ACTION. YOU EXPRESSLY WAIVE THE RIGHT TO PARTICIPATE IN ANY CLASS
                    ACTION, PRIVATE ATTORNEY GENERAL ACTION, OR ANY OTHER REPRESENTATIVE PROCEEDING.
                    THE ARBITRATOR MAY NOT CONSOLIDATE MORE THAN ONE PERSON’S CLAIMS OR PRESIDE OVER
                    ANY FORM OF A CLASS OR REPRESENTATIVE PROCEEDING.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    12.4 Costs of Arbitration
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    THE AAA’S RULES WILL GOVERN THE PAYMENT OF ALL FILING, ADMINISTRATIVE, AND
                    ARBITRATOR FEES. EACH PARTY WILL BEAR ITS OWN ATTORNEYS’ FEES AND COSTS, UNLESS
                    THE ARBITRATOR AWARDS OTHERWISE UNDER APPLICABLE LAW.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    12.5 Opt-Out Right
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    YOU MAY OPT OUT OF THIS ARBITRATION AGREEMENT BY SENDING A WRITTEN NOTICE OF
                    YOUR DECISION TO OPT OUT TO INFO@TOMARKET.COM WITHIN THIRTY (30) DAYS OF FIRST
                    ACCEPTING THESE TERMS. YOUR OPT-OUT NOTICE MUST INCLUDE YOUR FULL NAME, EMAIL
                    ADDRESS, AND A CLEAR STATEMENT THAT YOU WISH TO OPT OUT OF ARBITRATION.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    12.6 Severability
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    IF ANY PART OF THIS ARBITRATION AGREEMENT IS FOUND TO BE UNENFORCEABLE, THE
                    REMAINDER SHALL REMAIN IN EFFECT, EXCEPT THAT IF THE PROHIBITION ON CLASS OR
                    REPRESENTATIVE ACTIONS IS FOUND TO BE UNENFORCEABLE, THE ENTIRE ARBITRATION
                    AGREEMENT SHALL BE NULL AND VOID.
                  </MDTypography>
                </MDBox>

                {/* 13 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    13. NOTICE AND PROCEDURE FOR MAKING CLAIMS OF COPYRIGHT OR INTELLECTUAL PROPERTY
                    INFRINGEMENT.
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    13.1 Notice of Infringement
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    If you are a copyright owner or an agent thereof and believe that any user
                    submission or other content on the Platform infringes upon your copyrights, you
                    may submit a notification pursuant to the Digital Millennium Copyright Act
                    (“DMCA”) by providing us with the following information in writing (see 17
                    U.S.C. § 512(c)(3) for further detail):
                  </MDTypography>
                  <ol style={{ listStyleType: "lower-roman", paddingLeft: "4rem" }}>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        A physical or electronic signature of a person authorized to act on behalf
                        of the owner of an exclusive right that is allegedly infringed.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Identification of the copyrighted work claimed to have been infringed, or,
                        if multiple copyrighted works at a single online site are covered by a
                        single notification, a representative list of such works at that site
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Identification of the material that is claimed to be infringing or to be the
                        subject of infringing activity and that is to be removed or access to which
                        is to be disabled and information reasonably sufficient to permit us to
                        locate the material
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Information reasonably sufficient to permit us to contact you, such as an
                        address, telephone number, and, if available, an electronic mail address
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        A statement that you have a good faith belief that use of the material in
                        the manner complained of is not authorized by the copyright owner, its
                        agent, or the law.
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        A statement that the information in the notification is accurate, and under
                        penalty of perjury, that you are authorized to act on behalf of the owner of
                        an exclusive right that is allegedly infringed.
                      </MDTypography>
                    </li>
                  </ol>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    13.2 Address for Notices.
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    DMCA claims may be sent to the following addresses:
                  </MDTypography>

                  <MDBox mt={2} mb={1} ml={4}>
                    <Grid container spacing={2} alignItems="flex-start">
                      <Grid item xs={2}>
                        <MDTypography variant="body2" fontWeight="bold">
                          By email to:
                        </MDTypography>
                      </Grid>
                      <Grid item xs={10}>
                        <Link
                          to="mailto:info@tomarket.com"
                          style={{ fontWeight: "bold", textDecoration: "none", color: "#1976d2" }}
                        >
                          info@tomarket.com
                        </Link>
                      </Grid>
                    </Grid>
                  </MDBox>

                  <MDBox ml={4}>
                    <Grid container spacing={2} alignItems="flex-start">
                      <Grid item xs={2}>
                        <MDTypography variant="body2" fontWeight="bold">
                          By mail to:
                        </MDTypography>
                      </Grid>
                      <Grid item xs={10}>
                        <MDTypography variant="body2">
                          Find Better Food, Inc. <br />
                          Attention: David Moosman, CEO <br />
                          8776 W. 86th Dr. <br />
                          Arvada, CO 80005
                        </MDTypography>
                      </Grid>
                    </Grid>
                  </MDBox>

                  <MDBox mt={3}>
                    <MDTypography ml={2} variant="body2" paragraph>
                      <strong>NOTE:</strong> YOU ACKNOWLEDGE AND AGREE THAT IF YOU FAIL TO COMPLY
                      WITH ALL OF THE REQUIREMENTS OF THIS SECTION 13, YOUR DMCA CLAIM MAY NOT BE
                      VALID.
                    </MDTypography>
                  </MDBox>
                </MDBox>

                {/* 14 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    14. SPECIAL TERMS FOR TOMARKET APP DISTRIBUTED THROUGH THE APPLE APP STORE
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    PLEASE READ THIS SECTION CAREFULLY. IT AFFECTS YOUR RIGHTS.
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    14.1 Acknowledgement
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    The ToMarket App is available through the Apple App Store (“ToMarket App Apple
                    Version”). You and ToMarket each acknowledge that these Terms and any other
                    terms and conditions imposed by ToMarket with respect to the ToMarket App Apple
                    Version and any other agreements entered into between you and ToMarket in
                    connection with the ToMarket App Apple Version (collectively, the “ToMarket App
                    Apple Agreements”) are between you and ToMarket only, and not with Apple, and
                    that ToMarket, not Apple, is solely responsible for the ToMarket App Apple
                    Version and the content thereof. In the event the ToMarket App Apple Agreements
                    provide usage rules for the ToMarket App Apple Version that are in conflict with
                    the Apple Media Services Terms and Conditions, the Apple Media Services Terms
                    and Conditions shall control with respect to the ToMarket App Apple Version.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    14.2 Scope of License
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    In addition to the other terms set forth in the ToMarket App Apple Agreements,
                    the license granted to You for the ToMarket App Apple Version is solely for use
                    by you on any Apple-branded product that you own or control and as permitted by
                    the Usage Rules set forth in the Apple Media Services Terms and Conditions.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    14.3 Maintenance and Support
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    ToMarket is solely responsible for providing any maintenance and support
                    services with respect to the ToMarket App Apple Version, as specified in the
                    ToMarket App Apple Agreements or as required under applicable law. You and
                    ToMarket each acknowledge that Apple has no obligation whatsoever to furnish any
                    maintenance and support services with respect to the ToMarket App Apple Version.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    14.4 Warranty
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    ToMarket is solely responsible for any product warranties, whether express or
                    implied by law, to the extent not disclaimed in the ToMarket Apple App
                    Agreements. In the event of any failure of the ToMarket App Apple Version to
                    conform to any applicable warranty, you may notify Apple and Apple will refund
                    the purchase price for the ToMarket App Apple Version (if any) to you. Further,
                    to the maximum extent permitted by applicable law, Apple will have no other
                    warranty obligation whatsoever with respect to the ToMarket App Apple Version,
                    and, subject to the limitations of liability set forth in the ToMarket App Apple
                    Agreements, any other claims, losses, liabilities, damages, costs or expenses
                    attributable to any failure to conform with any warranty will be ToMarket’s sole
                    responsibility.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    14.5 Product Claims
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    You and ToMarket each acknowledge that ToMarket, not Apple, is responsible for
                    addressing any claims that you or any third party have relating to the ToMarket
                    App Apple Version or your possession and/or use of the ToMarket App Apple
                    Version, including, but not limited to:
                  </MDTypography>
                  <ol style={{ listStyleType: "lower-roman", paddingLeft: "4rem" }}>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Product liability claims
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        Any claim that the ToMarket App Apple Version fails to conform to any
                        applicable legal or regulatory requirement
                      </MDTypography>
                    </li>
                    <li>
                      <MDTypography variant="body2" paragraph>
                        claims arising under consumer protection, privacy or similar legislation.
                      </MDTypography>
                    </li>
                  </ol>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    14.6 Intellectual Property Rights
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    You and ToMarket each acknowledge that, in the event of any third party claim
                    that the ToMarket App Apple Version or your possession and use of the ToMarket
                    App Apple Version infringes that third party’s intellectual property rights,
                    subject to the limitations of liability and indemnification obligations set
                    forth in the ToMarket App Apple Agreements, ToMarket, not Apple, will be solely
                    responsible for the investigation, defense, settlement and discharge of any such
                    intellectual property infringement claim.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    14.7 Third Party Terms
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    You must comply with applicable third party terms when using the ToMarket App
                    Apple Version.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    14.8 Third Party Beneficiary
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    You and ToMarket each acknowledge and agree that Apple, and Apple’s
                    subsidiaries, are third party beneficiaries to these Terms as applicable to the
                    ToMarket App Apple Version, and that, upon your acceptance of these Terms, Apple
                    will have the right (and will be deemed to have accepted the right) to enforce
                    these Terms (as applicable) against you as a third party beneficiary thereof.
                  </MDTypography>
                </MDBox>

                {/* 15 */}
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    15. ADDITIONAL TERMS
                  </MDTypography>

                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    15.1 Governing Law
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    These Terms will be governed by the laws of the State of Colorado, without
                    giving effect to any principles of conflicts of laws.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    15.2 Severability
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    If any part of these Terms are determined to be invalid or unenforceable
                    pursuant to applicable law, including, but not limited to, the warranty
                    disclaimers and liability limitations set forth above, then the invalid or
                    unenforceable provision will be deemed superseded by a valid, enforceable
                    provision that most closely matches the intent of the original provision and the
                    remainder of the applicable Agreements shall continue in effect.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    15.3 Waivers
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    Our failure to enforce any provision of the Agreements shall not be deemed a
                    waiver of such provision nor of the right to enforce such provisions.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    15.4 Admissibility of Terms
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    A printed version of these Terms and of any notice given in electronic form
                    shall be admissible in judicial or administrative proceedings based upon or
                    relating to these Terms to the same extent and subject to the same conditions as
                    other business documents and records originally generated and maintained in
                    printed form.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    15.5 Assignment
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    We reserve the right to transfer, assign, sublicense or pledge any or all of the
                    Agreements, in whole or in part, to any person without notice, provided that any
                    such assignment will be on the same terms or terms that are no less advantageous
                    to you. You may not assign, sublicense or otherwise transfer in any manner
                    whatsoever any of your rights or obligations under the Agreement.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    15.6 Headings
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    The section headings and sub-headings contained in these Terms are for
                    convenience only and have no legal or contractual effect.
                  </MDTypography>
                  <MDTypography ml={2} variant="h6" fontWeight="medium" gutterBottom>
                    15.7 Support
                  </MDTypography>
                  <MDTypography ml={2} variant="body2" paragraph>
                    If you have any questions or concerns about the Platform or these Terms, please
                    email us at{" "}
                    <strong>
                      <Link
                        to="mailto:info@tomarket.com"
                        style={{ fontWeight: "bold", textDecoration: "none", color: "#1976d2" }}
                      >
                        info@tomarket.com
                      </Link>
                    </strong>{" "}
                    .
                  </MDTypography>
                </MDBox>
              </MDBox>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default TermsAndConditions;
